import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { CACHE_TIME, STALE_TIME, USE_LIST_PLAYERS_BY_TEAM_ID, } from "../ApiProvider";
import { api } from "./api";
import { USE_RETRIEVE_TEAM_FEED } from "./queryKeys";
const USE_LIST_USER_TRANSFER_REQUESTS = "useListUserTransferRequests";
const USE_RETRIEVE_TRANSFER_REQUEST = "useRetrieveTransferRequest";
export const useListUserTransferRequests = () => {
    return useQuery({
        queryKey: [USE_LIST_USER_TRANSFER_REQUESTS],
        queryFn: async () => {
            const response = await api.get(`/transfer-requests/user-transfer-requests/`);
            return response.data;
        },
        staleTime: STALE_TIME,
        cacheTime: CACHE_TIME,
    });
};
export const useRetrieveTransferRequest = ({ id, }) => {
    return useQuery({
        queryKey: [USE_RETRIEVE_TRANSFER_REQUEST, id],
        queryFn: async () => {
            const response = await api.get(`/transfer-requests/${id}/`);
            return response.data;
        },
        enabled: !!id,
        staleTime: STALE_TIME,
        cacheTime: CACHE_TIME,
    });
};
export const useCreateTransferRequest = ({ team, onMutate, onSuccess, onError, }) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async () => {
            if (!team) {
                throw new Error("Team is not defined!");
            }
            return api.post(`/teams/${team.id}/transfer-requests/`);
        },
        onMutate,
        onSuccess: (data) => {
            queryClient.invalidateQueries([USE_LIST_USER_TRANSFER_REQUESTS]);
            onSuccess(data);
        },
        onError,
    });
};
export const useProcessTransferRequest = ({ transferRequest, onMutate, onSuccess, onError, }) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (processTransferRequest) => {
            if (!transferRequest) {
                throw new Error("Transfer Request is not defined!");
            }
            return api.put(`/process-transfer-request/${transferRequest.id}/`, processTransferRequest);
        },
        onMutate,
        onSuccess: (data) => {
            queryClient.invalidateQueries([
                USE_LIST_PLAYERS_BY_TEAM_ID,
                transferRequest.team,
            ]);
            queryClient.invalidateQueries([
                USE_RETRIEVE_TEAM_FEED,
                transferRequest.team,
            ]);
            onSuccess(data);
        },
        onError,
    });
};
export const useCancelTransferRequest = ({ transferRequest, onMutate, onSuccess, onError, }) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async () => {
            if (!transferRequest) {
                throw new Error("Transfer Request is not defined!");
            }
            return api.delete(`/cancel-transfer-request/${transferRequest.id}/`);
        },
        onMutate,
        onSuccess: (data) => {
            queryClient.invalidateQueries([USE_LIST_USER_TRANSFER_REQUESTS]);
            queryClient.removeQueries([
                USE_RETRIEVE_TRANSFER_REQUEST,
                transferRequest.id,
            ]);
            onSuccess(data);
        },
        onError,
    });
};
